export function buildAlternativesViewQueryV1(workspaceId: number, alternativesListId: number, viewDefId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesViews.Queries.AlternativesViewQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'AlternativesListId': alternativesListId,
		'ViewDefId': viewDefId,
	}
}

export function buildListsPageQueryV1(workspaceId: number, projectId: number, viewDefId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesViews.Queries.ListsPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'ViewDefId': viewDefId,
	}
}

export function buildListDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativesViewId: string)
{
	return {
		'$type': 'TCh.Domain.Alternatives.AlternativesViews.Queries.ListDependenciesQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'AlternativesViewId': alternativesViewId,
	}
}

